<div class="container-fluid" [class]="deviceDetector.isMobile() ? 'content-' + interaction?.orientation : ''" [class.pb-completed]="interaction?.completed.onComplete || interaction?.tentativiMax">
  <div class="row">
    <div class="col-12 pt-3 interaction-header mb-3" [class]="'header-' + interaction?.type">
      <h3 class="text-center text-white text-uppercase font-weight-bold mb-2">
        {{interaction?.title}}
      </h3>
      <p class="text-center text-white font-italic" [innerHtml]="interaction?.instructions"></p>
    </div>

    <app-games class="col-12" *ngIf="interaction?.type === 'game'" [interaction]="interaction"></app-games>
    <app-video class="col-12" *ngIf="interaction?.type === 'video'" [interaction]="interaction"></app-video>
    <app-audio class="col-12" *ngIf="interaction?.type === 'audio'" [interaction]="interaction"></app-audio>
    <app-image class="col-12" *ngIf="interaction?.type === 'image'" [interaction]="interaction"></app-image>
  </div>

</div>
<div id="toast" class="container-fluid" [class]="deviceDetector.isMobile() ? 'content-' + interaction?.orientation : ''">
  <div class="text-center row bg-white" *ngIf="interaction?.completed.onComplete || interaction?.tentativiMax">
    <!-- COMPLETED WITH SUCCESS-->
    <div class="col-10 offset-1 mt-3 bg-white" *ngIf="interaction?.completed.status === 'success'">
      <h3 [innerHTML]="interaction?.onComplete.messages.success.title"></h3>
      <p [innerHTML]="interaction?.onComplete.messages.success.body"></p>
    </div>
    <div class="col-10 offset-1 mt-3 bg-white" *ngIf="interaction?.completed.status === 'failed' && !interaction?.tentativiMax">
      <h3 [innerHTML]="interaction?.onComplete.messages.failed.title"></h3>
      <p [innerHTML]="interaction?.onComplete.messages.failed.body"></p>
    </div>
    <!-- INTERACTION WITH TENTATIVI-->
    <div class="col-10 offset-1" *ngIf="interaction?.tentativiMax">
      <!-- COMPLETED WITH FAIL-->
      <div class="bg-white mt-3 mb-3" *ngIf="interaction?.completed.status === 'failed'">
        <h3 [innerHTML]="interaction?.onComplete.messages.failed.title"></h3>
        <p [innerHTML]="interaction?.onComplete.messages.failed.body"></p>
      </div>
    </div>
    <div class="col-12" *ngIf="interaction?.completed.onComplete">
      <a href="Javascript:;" class="btn btn-outline-dark btn-rounded" (click)="onComplete(interaction)"  *ngIf="interaction?.completed.status === 'success' && interaction?.onComplete.contentType !== null"><i class="fa fa-chevron-right text-warning mr-1"></i>
        <span *ngIf="language ==='it'">Avanti</span>
        <span *ngIf="language ==='en'">Continue</span>
        <span *ngIf="language ==='fr'">Continue</span>
      </a>
      <!--<a href="Javascript:;" class="btn btn-outline-dark btn-rounded" (click)="onComplete(interaction)"  *ngIf="interaction?.completed.status === 'failed' && interaction?.onComplete.contentType">Continua</a>-->
      <a href="Javascript:;" *ngIf="interaction?.completed.onComplete" class="d-block mb-4 text-center text-medium text-small" (click)="onResetInteraction()"><i class="fa fa-undo-alt mr-1"></i>
        <span *ngIf="language ==='it'">Gioca di nuovo</span>
        <span *ngIf="language ==='en'">Play again</span>
        <span *ngIf="language ==='fr'">Rejouer</span>
      </a>
    </div>
  </div>
</div>
<app-orientation-alert *ngIf="deviceDetector.isMobile()" [orientation]="interaction?.orientation" [class]="'turn-to-' + interaction?.orientation"></app-orientation-alert>
